import { RemoveFormItem } from "@/components/RemoveFormItem";
import { selectFilterHelper } from "@/helpers";
import { optionFieldType, optionType } from "@/propTypes";
import { Form, Input, Select, Space } from "antd";
import { arrayOf, func } from "prop-types";
import { useIntl } from "react-intl";

export const OptionValue = ({ field, remove, availableDependantValues }) => {
  const intl = useIntl();
  return (
    <Space key={field.key} style={{ display: "flex", alignItems: "center" }}>
      <Form.Item
        isListField={field.isListField}
        name={[field.name, "fallback"]}
        fieldKey={[field.fieldKey, "fallback"]}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.optionLabelRequired",
            }),
          },
        ]}
      >
        <Input
          placeholder={intl.formatMessage({
            id: "newFormField.optionLabelPlaceholder",
          })}
        />
      </Form.Item>
      <Form.Item
        isListField={field.isListField}
        name={[field.name, "dependsOnPropertyValues"]}
        fieldKey={[field.fieldKey, "dependsOnPropertyValues"]}
      >
        <Select
          mode="multiple"
          style={{ maxWidth: 500, minWidth: 300 }}
          allowClear
          placeholder={intl.formatMessage({
            id: "newFormField.dependentValuesPlaceholder",
          })}
          filterOption={selectFilterHelper}
        >
          {availableDependantValues.map(({ value, text }) => (
            <Select.Option value={value} key={value}>
              {text}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <RemoveFormItem
        parentComponent="option-value"
        uniqueKey={field.name}
        remove={() => remove(field.name)}
      />
    </Space>
  );
};

OptionValue.propTypes = {
  field: optionFieldType.isRequired,
  remove: func.isRequired,
  availableDependantValues: arrayOf(optionType).isRequired,
};
